import type { RangePerContig } from "../../store/slices/selection-slice.ts";

export function getMaxRangeLength(rangeSelections: RangePerContig[]): number {
  return Math.max(...rangeSelections.map((range) => range.stop - range.start + 1));
}
